<template>
  <div class="mobile mission">
    <Transition name="fade">
      <div class="mission-mask" @click="$emit('update:showMission', false)" v-if="props.showMission"></div>
    </Transition>
    <div class="mission-content" :class="{ show: props.showMission }">
      <div class="mission-header">
        {{ $t('mwr.mission.header') }}
      </div>
      <div class="mission-list">
        <MissionItem v-for="item in state.missionList" :key="item.id" :mission="item" />
      </div>
      <div class="close close-btn" @click="$emit('update:showMission', false)"></div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, defineProps, defineEmits } from 'vue'
import MissionItem from './Item.vue'
const emit = defineEmits(['update:showMission'])
const props = defineProps({
  showMission: {
    type: Boolean,
    default: false
  }
})
const state = reactive({
  missionList: [
    {
      id: 1,
      key: 'dailyLogin',
      // turn: 1,
      totle: 1,
      // current: 0,
      received: 1,
    },
    {
      id: 2,
      key: 'loginDaysGt3',
      // turn: 7,
      totle: 3,
      // current: 2,
      received: 0,
    },
    {
      id: 3,
      key: 'loginDaysGt7',
      // turn: 2,
      totle: 7,
      // current: 2,
      received: 0,
    },
    {
      id: 4,
      key: 'shareMwr',
      // turn: 1,
      totle: 1,
      // current: 2,
      received: 0,
    },
    {
      id: 5,
      key: 'dailyPlayThreeMode',
      // turn: 2,
      totle: 3,
      // current: 2,
      received: 0,
    },
    {
      id: 6,
      key: 'playedFiveNewMode',
      // turn: 5,
      totle: 5,
      // current: 2,
      received: 0,
    }
  ]
})
</script>

<style scoped lang="less" src="./mobile_style.less"></style>